<template>
  <div class="tabs-header">
    <div class="page-back" @click="goBack">
      <img src="@/assets/images/icon-back.png" alt="" />
    </div>

    <div class="tabs">
      <van-tabs
        swipeable
        animated
        v-model="currentIndex"
        color="#FF7A3E"
        line-width="50px"
        line-height="3px"
        @change="tabChange"
      >
        <van-tab
          v-for="item in tabs"
          :key="item.value"
          :title="item.label"
          :name="item.value"
        >
        </van-tab>
      </van-tabs>
    </div>

    <span @click="tipHandle" class="tips" v-if="ifRight">温馨提示</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: ''
    };
  },
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
    activeIndex: {
      type: String,
      default: ""
    },
    ifRight: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.currentIndex = this.activeIndex
  },
  methods: {
    tabChange() {
      this.$emit("tabEvent", this.currentIndex);
    },
    goBack() {
      this.$router.go(-1);
    },
    tipHandle() {
      this.$emit("tipEvent");
    }
  },
};
</script>

<style lang="scss">
.tabs-header {
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  width: 750px;
  height: 88px;
  padding: 0 120px;
  position: relative;

  position: sticky;
  top: 0;
  z-index: 9999;
  background: #fff;
  .page-back {
    position: absolute;
    left: 30px;
    top: 25px;
    img {
      width: 20px;
      height: 36px;
    }
  }
  .tips {
    position: absolute;
    right: 30px;
    top: 32px;
    font-size: 22px;
    color: #ff7a3e;
    text-decoration: underline;
    
  }
  .van-tabs--line .van-tabs__wrap {
    height: 88px;
  }
  .van-tab__text {
    font-weight: 400;
    font-size: 32px;
    color: #414141;
    line-height: 45px;
  }
  .van-tab--active .van-tab__text {
    color: #ff7a3e;
    font-weight: 600;
    font-size: 36px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TabHeader.vue